import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Environment, mockIdentity, MockSession, Session, SessionProvider, Status, Type } from '@lendi/lala-react';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { Theme } from '@lendi/ui';
import App from 'scaffold';
import { getTypeFromHostname, getBrandFromHostname } from '@lendi/lala-utils';
import { mapBrandToPath } from 'utils/helpers';

const buildType = process.env.NODE_ENV;

datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID!,
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
  site: process.env.REACT_APP_DATADOG_SITE,
  env: process.env.REACT_APP_ENVIRONMENT,
  service: process.env.REACT_APP_DATADOG_SERVICE_ID,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 50,
  trackUserInteractions: true,
});

datadogLogs.init({
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
  site: process.env.REACT_APP_DATADOG_SITE,
  env: process.env.REACT_APP_ENVIRONMENT,
  service: process.env.REACT_APP_DATADOG_SERVICE_ID,
  sessionSampleRate: 100,
});

const getViewType = () => {
  const { pathname } = window.location;
  if (buildType === 'development') {
    // for local run
    return pathname.includes('/team-view/') ? Type.Team : Type.Customer;
  }

  return getTypeFromHostname();
};

let session = new Session({
  brand: getBrandFromHostname(),
  type: getViewType(),
  environment: (process.env.REACT_APP_ENVIRONMENT as Environment) || Environment.Development,
});

datadogLogs.setUser({
  id: session.identity?.id,
  type: session.type,
});

if (process.env.REACT_APP_BYPASS_AUTH === 'true') {
  console.log('🧍Mocking session');
  const userId = process.env.REACT_APP_USER_ID;
  session = new MockSession(
    {
      brand: getBrandFromHostname(),
      type: getTypeFromHostname(),
      environment: (process.env.REACT_APP_ENVIRONMENT as Environment) || Environment.Development,
    },
    userId
      ? {
          id: userId,
        }
      : mockIdentity
  );
  (session as MockSession).setToken(process.env.REACT_APP_TEST_TOKEN || '');
  (session as MockSession).setExpiry(Date.now() + 60 * 1000);
  (session as MockSession).setStatus(Status.Authenticated);
}

ReactDOM.render(
  <BrowserRouter basename={mapBrandToPath(session.brand, session.type)}>
    <SessionProvider session={session} developAsAuthenticated={buildType === 'development'}>
      <Theme name={session.brand}>
        <App />
      </Theme>
    </SessionProvider>
  </BrowserRouter>,
  document.getElementById('app')
);
